
  import VueRouter from 'vue-router';
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { inject } from 'inversify-props';
  import { IAuthService, IMealCountService } from '@/services';
  import { types } from '@/store';
  import { routePaths } from '@/router'
  import { eventBus, mcEvents, mcDate } from "@/utils";

  @Component
  export default class MCFooter extends Vue {
    @inject() private authService!: IAuthService;
    @inject() private mealCountService!: IMealCountService;
    @inject() private router!: VueRouter;

    onDashboard: boolean = false;


    created() {
      eventBus.$on(mcEvents.sessionTimedOut, this.resetDashboard);
    }

    @Watch('$route', {immediate: true, deep: true})
    showResetButton() {
        if (this.$route.path === routePaths.dashboard.path) {
          this.onDashboard = true;
        }
        else {
          this.onDashboard = false;
        }
    }

    resetDashboard() {
      this.$store.dispatch(types.actions.setSelectedMealDate, '');
      this.$store.dispatch(types.actions.setSelectedSiteId, 0);
      this.$store.dispatch(types.actions.setTimeStamp, 0);
      eventBus.$emit(mcEvents.selectionsCleared);
    }

    get isAuthenticated() {
      return this.$store.getters[types.state.isAuthenticated];
    }

    get userName() {
      const user = this.$store.getters[types.state.user];
      return user !== null ? user.userName : '';
    }

    get notSynced() {
      return this.mealCountService.unsyncedMeals.length;
    }

    async goToProfile() {
      await this.authService.profile();
    }

    async goToChangePassword() {
      await this.authService.changePassword();
    }

    async goToAdmin() {
      if (this.$store.state.counter.isOnline) {
        const timezone = mcDate.timeZone();
        const adminUrl = this.$store.state.auth.appConfigSettings.adminUrl;
        location.replace(`${adminUrl}Users/UserLogin?localTimezone=${timezone}`);
      }
      else {
        this.router.push(routePaths.offline.path);
      }
    }

    async logout() {
      this.$bvModal.hide('logoutModal');
      if (navigator.onLine) {
        this.resetDashboard();
        this.authService.startLogout();
      }
      else {
        await this.authService.offlineLogout();
      }
    }

    toggleTermsOfUse() {
      this.$bvModal.show('TermsModal');
    }

    togglePrivacyPolicy() {
      this.$bvModal.show('PrivacyModal');
    }

    get currentYear() {
      return new Date().getFullYear();
    }
  }
